import { render, staticRenderFns } from "./TheRequestCreditsPanel.vue?vue&type=template&id=7987895f&scoped=true"
import script from "./TheRequestCreditsPanel.vue?vue&type=script&lang=js"
export * from "./TheRequestCreditsPanel.vue?vue&type=script&lang=js"
import style0 from "./TheRequestCreditsPanel.vue?vue&type=style&index=0&id=7987895f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7987895f",
  null
  
)

export default component.exports